import { Box, Grid } from "@mui/material";

import SampleOriginDistribution from "./SampleOriginDistribution";
import ModalTrigger from "../Common/ModalTrigger";
import csv1 from "../../Data/MANCP/Geospatial/MANCP-Sample-origin-per-country-of-sampling.csv";
import HorizontalBarChart from "../Charts/HorizontalBarChart";

const SamplingRegion = (props) => {
  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{
        marginTop: { xs: "50px", sm: "50px", md: "30px" },
        textAlign: { xs: "left", sm: "center", md: "left" },
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Grid
        item
        xs
        className="two-one"
        sx={{
          paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
          paddingRight: { xs: "24px", sm: "45x", md: "24px" },
          paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
          maxWidth: { md: "450px !important" },
        }}
      >
        <Box>
          <h3>Origin of samples</h3>
          <p className="paragraph">
            Of the 132,793 samples analysed, 43.2% were from the same reporting countries (i.e.{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="domestic samples"
            />
            ), 10.7% from a different reporting country, while 42.1% had been imported to the EU from third countries. The remaining 4% were reported as being of unknown origin.
          </p>
          <p className="paragraph">
            Of the 71,617 samples from the reporting countries, 63.8% were found to be below the LOQ, while 34.4% contained residues at or above the LOQ but below or equal to the MRL; 1.8% of the samples{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , and of these, 1% were not compliant with the{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="MRL"
            />
            .
          </p>
          <p className="paragraph">
            Of the 55,932 samples imported from third countries, 50.9% had no quantifiable residues, while 42.9% of samples contained quantifiable residues within the MRLs. Samples from third countries were found to have a higher MRL exceedance rate (6.2%) and a higher{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliance rate"
            />{" "}
            (3.4%) than samples of food produced in the EU.
          </p>

          <Box display="flex" flexDirection="column">
            <SampleOriginDistribution />
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs
        className="two-two"
        justifyContent="center"
        alignItems="center"
        sx={{
          paddingLeft: { xs: "10px", sm: "10px", md: "24px" },
          paddingRight: { xs: "40px", sm: "40px", md: "24px" },
          paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
          width: "100%",
        }}
      >
        <HorizontalBarChart
          csv={csv1}
          title="Sample origin percentage per country of sampling"
          yField="country"
          xField="value"
          transform={true}
          stackField="region"
        />
      </Grid>
    </Grid>
  );
};

export default SamplingRegion;
